import { Component, Input, OnInit,ChangeDetectorRef } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'

import { DialogService, StateService,VisiteService,CourrierService } from '../../../../../services'

import { ChoiceCourrierComponent } from "../../../layout/dialogs/choice-courrier-dialog/choice-courrier.component"
import { CourrierDialog } from "../../../layout/dialogs/courrier-dialog/courrier-dialog.component"
import { LoadDialogComponent } from '../../../layout/dialogs/load-dialog/load.component'
import { ConfirmComponent } from '../../..//layout/dialogs/confirm-dialog/confirm.component'

import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { of,Observable, Subject  } from 'rxjs'

const KEY = 'dossier-rdv-courrier'

@Component({
  selector: 'atyl-dossier-rdv-courrier',
  templateUrl: './dossier-rdv-courrier.component.html',
  styleUrls: ['./dossier-rdv-courrier.component.scss']
})
@Stringable({
  path: 'views/partials/content/dossier/dossier-rdv-courrier',
  key: KEY,
})
export class DossierRdvCourrierComponent implements OnInit {

 @Input() eventLoad: Observable<boolean>;
  expanded: boolean = true;
  @Input() courriers: any[] = [];
  @Input() tiers: any
  @Input() visite: any
  @StringableValues(KEY) strings: any

  user:any;
  
  constructor(
	private stateService: StateService,
	private dialogService: DialogService,
	private courrierService: CourrierService,
	private visiteService:  VisiteService,
	private changeDetectorRef: ChangeDetectorRef,
		
  ) { }

  ngOnInit() {
	console.log("DossierRdvCourrierComponent init",this.tiers,this.visite,this.eventLoad)
	if (this.eventLoad!=undefined)
		this.eventLoad.subscribe((loading:boolean) => {
			console.log("DossierRdvCourrierComponent init event",loading);
				if (loading)  {
					this._loadCourrier();
				}
		});
	
	this.stateService.user.subscribe((user) => {
	        if (user) {
	            this.user = user;
	            console.log("DossierRdvCourrierComponent user",this.user);
	           
	        }

	    })	
		
  }
  
  _loadCourrier() {
	this.courriers=[];
	
	let _opts:any={
		visite:this.visite,
		consultation: this.visite.consultation
	}
	console.log("DossierRdvCourrierComponent _loadCourrier",_opts);
	this.visiteService.getCourrierList(this.visite.ID,_opts).subscribe((res: JSONRpcResponse) => {
				console.log("DossierRdvCourrierComponent _loadCourrier",_opts,res);
				
				if (res.result) {
					
					this.courriers=res.result;
					this.changeDetectorRef.detectChanges();
				}
	});
  }
  
  
  getChoiceCourrier(instruction: any): void{
       let droitcourier:any[]=[];
  		
	   let panierLine:any={
			dossier	: this.tiers,
						
			visite	:this.visite,
			
	   }
	   
	   
      const dialogRef = this.dialogService.open(ChoiceCourrierComponent,{
        data: {
         // instruction : instruction,
          typeDemandeID: 'SEANCE',
		  panierLines: [panierLine],
		  consultation: this.visite.consultation
         /* typeDemande: instruction.demande,*/
                /*  state: this.currentState,*/
       /*   dossier: this.dossier,
          droits: droitcourier*/
        },
             /* width: "50vw",*/
              resizable: false,
              minimizable: true,
              draggable: false,
              maximizable: true
      });
      dialogRef.afterClosed().subscribe((result) => {
  		 console.log("InstructionComponent ChoiceCourrierComponent",result);
        
        if(result){
  		   if (result!=undefined && result
  	                && result.zipFile!=undefined 
  	                && result.zipFile.url!=undefined 
  	                 && result.zipFile.url
  	                ) {
  					//	window.open(result.zipFile.url,' _blank');
					const dial=this.dialogService.open(LoadDialogComponent, {
						data: {
							url: result.zipFile.url
						},
						height: "95vh",
						width: "80%",
						minimizable: true,
						maximizable: true,
						draggable: true,
					}, (res: any) => {})
					
  			}
             /*this.isLoadDossier=false;
             this.isLoadAgrement=false;
             this.isLoadFormation=false;
             this.isLoadInstruction=false;      
               this.tabInstructionLoad();*/
            // this.reloadDossier();
             
        }
      });
      
      const sub = dialogRef.componentInstance.onFormClosed.subscribe((result: any) => {
              console.log('createCouurierDialog after form refesh',result);
              if (result) {
                 // this.initInstruction(false,false,true,false,false); 
				 this._loadCourrier();
              }
  	    }
  	  )
      
    }
	
	getCourrier(instruction: any, courrier ?: any, editable = true): void {
	       console.log("getCourrier",courrier,editable);
	        const dialogRef = this.dialogService.open(CourrierDialog, {
	            data: {
					dossier	: {
						ID:this.tiers.dossierID,
						tiers: this.tiers
					},	
			        courrier : courrier,
			        isEditable: editable,
			        demandeId : courrier.ID
	            },
	            width: "80vw",
	            resizable: true,
	            minimizable: true,
	            draggable: true,
	            maximizable: true
	        });

	        dialogRef.afterClosed().subscribe(result => {
		        console.log("getCourrier close",result)
	            if(result){
	            //this.reloadDossier();
	                 if (result!=undefined && result
		                && result.ziFile!=undefined 
		                && result.ziFile.url!=undefined 
		                 && result.ziFile.url
		                ) {
							//window.open(result.zipFile.url,' _blank');
							const dial=this.dialogService.open(LoadDialogComponent, {
							data: {
								url: result.zipFile.url
							},
							height: "95vh",
							width: "80%",
							minimizable: true,
							maximizable: true,
							draggable: true,
						}, (res: any) => {})
							
						}
	                
	           		 this._loadCourrier();
	            }
	        });
	  }
	  
	  download(url: string) {
	           //  window.open(url,' _blank');
	  		const dial=this.dialogService.open(LoadDialogComponent, {
	  				               data: {
	  				                   url: url
	  				               },
	  							   height: "95vh",
	  							   width: "80%",
	  							   minimizable: true,
	  							   maximizable: true,
	  							   draggable: true,
	  				           }, (res: any) => {
	  				               
	  				           })
	  }
	  
	  deleteCourrier(demandeCourrier: any) {
	          if (demandeCourrier) {
	              this.dialogService.open(ConfirmComponent, {
	                  data: {
	                      libelle: this.strings.confirmMessages.deleteCourrier
	                  },
	                  draggable: true,
	              }, (res: any) => {
	                  if (res && res === 'true') {
	                      this.courrierService.setCourrierDelete(demandeCourrier.ID).subscribe((forms: JSONRpcResponse) => {
	                       
	                       this._loadCourrier();
	                          
	                      })
	                  }
	              })
	          }
	      }
	      
	      restoreCourrier(demandeCourrier: any) {
	          if (demandeCourrier) {
	              this.dialogService.open(ConfirmComponent, {
	                  data: {
	                      libelle: this.strings.confirmMessages.restoreCourrier
	                  },
	                  draggable: true,
	              }, (res: any) => {
	                  if (res && res === 'true') {
	                      this.courrierService.setCourrierRestore(demandeCourrier.ID).subscribe((forms: JSONRpcResponse) => {
	                        
	                         this._loadCourrier();
	                      })
	                  }
	              })
	          }
	      }

}
